import { Analytics } from "@vercel/analytics/react";
import React from "react";
import "./App.css";
import Calculator from "./components/Calculator";

function App() {
  return (
    <div className="App">
      <Calculator />
      <Analytics />
    </div>
  );
}

export default App;
